import { app } from '../../../../app';

class AuthenticationPoliciesService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    GetCurrentPasswordAuthenticationSettings(companyId,id) {
        const url = `app/rest/v2/company/${companyId}/applications/${id}/pwdauthpolicy`;
        return this.$http.get(url).then(({data}) => data);
    }
    GetCurrentAuthenticationPoliciesSettings(companyId,id) {
        const url = `app/rest/v2/company/${companyId}/applications/${id}/pwdauthpolicy`;
        return this.$http.get(url).then(({data}) => data);
    }

    UpdateCurrentPasswordAuthenticationSettings(companyId,id,passwordAuthenticationSettings) {
        const url = `app/rest/v2/company/${companyId}/applications/${id}/pwdauthpolicy`;
        return this.$http.put(url, passwordAuthenticationSettings).then(({data}) => data);
    }

    GetCurrentAdaptiveAuthenticationSettings(companyId,id) {
        const url = `app/rest/v2/company/${companyId}/applications/${id}/adapauthsettings`;
        return this.$http.get(url).then(({data}) => data);
    }

    UpdateCurrentAdaptiveAuthenticationSettings(companyId,id,adaptiveAuthenticationSettings) {
        const url = `app/rest/v2/company/${companyId}/applications/${id}/adapauthsettings`;
        return this.$http.put(url, adaptiveAuthenticationSettings).then(({data}) => data);
    }

}

app.service('AuthenticationPoliciesService', AuthenticationPoliciesService);



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/authentication-policies.service.js